import { CONTROL, TYPE } from '../chrome';

export function adminFieldSx() {
  return {
    '& .MuiInputBase-root': {
      minHeight: CONTROL.height,
      fontFamily: TYPE.ui,
      ...TYPE.body,
    },
  };
}

export function adminSelectSx() {
  return {
    minWidth: 220,
    bgcolor: 'transparent',
    fontFamily: TYPE.ui,
    ...adminFieldSx(),
  };
}
